import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Space, Table } from 'antd';

import useDatasource, { filterText } from '../../hooks/useDatasource';
import Column from '../../helpers/columns';

import { downloadAll, getEnrolledProducts } from '../../services/stocks/cards';
import PageTitle from '../PageTitle';
import ExportEntitiesButton from '../buttons/ExportEntitiesButton';
import useDictionaries from '../../hooks/useDictionaries';
import { findAll } from '../../services/stocks/article-types';

export const ProductStatus = {
  content: [
    { id: 'ENROLLED' },
    { id: 'DELETED' },
    { id: 'BLANK' },
    { id: 'DEFECTIVE' },
    { id: 'USABLE' },
    { id: 'REGISTERED' },
    { id: 'BLOCKED' },
    { id: 'UP_FOR_BLOCKING' },
    { id: 'UP_FOR_UNBLOCKING' },
    { id: 'EXPIRED' },
    { id: 'SOLD' },
  ],
  loading: false,
  error: false,
};

const EnrolledProductsList = () => {
  const { t } = useTranslation();

  const dictionaries = useMemo(
    () => ({
      articleTypes: findAll,
    }),
    [],
  );

  const [{ articleTypes }] = useDictionaries(dictionaries);

  const { pagination, content, sort, criterias, handleChange } =
    useDatasource(getEnrolledProducts);

  const columns = useMemo(
    () => [
      Column.text('id', t('components.enrolledProducts.id'), {}),
      Column.dictionary(
        'articleTypeName',
        t('components.enrolledProducts.articleType'),
        articleTypes,
        {
          sort: false,
          filter: true,
          dictLabel: 'name',
          dictKey: 'name',
        },
      ),
      Column.text('serial', t('components.enrolledProducts.serial'), {
        filter: true,
      }),
      {
        title: t('components.enrolledProducts.physicalId'),
        dataIndex: 'physicalId',
        key: 'physicalId',
        width: 300,
        sorter: true,
        render: (physicalId) => Number(physicalId),
        ...filterText(t('components.enrolledProducts.physicalId')),
      },
      Column.dictionary(
        'status',
        t('components.enrolledProducts.status._'),
        ProductStatus,
        {
          width: 150,
          filter: true,
          dictLabel: (entry) =>
            t(`components.enrolledProducts.status.${entry.id}`),
        },
      ),
      Column.text('hex', t('components.enrolledProducts.hex'), {
        filter: true,
      }),
      Column.text('createdBy', t('components.enrolledProducts.createdBy'), {
        sort: false,
      }),
      Column.date('createdAt', t('components.enrolledProducts.createdAt'), {
        sort: false,
      }),
      Column.text('updatedBy', t('components.enrolledProducts.updatedBy'), {
        sort: false,
      }),
      Column.date('updatedAt', t('components.enrolledProducts.updatedAt'), {
        sort: false,
        filter: true,
      }),
    ],
    [t, articleTypes],
  );

  return (
    <>
      <PageTitle>
        <Space>
          <ExportEntitiesButton
            columns={columns}
            data={{
              sort,
              criterias,
            }}
            downloadFiles={downloadAll}
          />
        </Space>
      </PageTitle>
      <Table
        rowKey="id"
        columns={columns}
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
        size="small"
      />
    </>
  );
};

export default EnrolledProductsList;
